import {Controller} from "react-hook-form";
import React from "react";
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css';
import './DatePickerControl.scss' ;

const DatePickerControl = ({ name, control,  placeHolder, validate, readOnly, showTimeInput, maxDate }) =>
{
    return (
        <Controller
            name={name}
            control={control}
            rules={{ validate: validate}}
            render={({field:{ onChange, value }}) => (
                <div className='date-wrapper'>
                    <DatePicker
                        placeholderText={placeHolder}
                        selected={value}
                        maxDate={maxDate}
                        onChange={onChange}
                        disabled={readOnly}
                        wrapperClassName="datePicker"
                        dateFormat="dd/MM/yyyy"
                        dateFormatCalendar="MMMM"
                        showYearDropdown
                        showTimeInput={showTimeInput}
                        yearDropdownItemNumber={30}
                        scrollableYearDropdown
                    />
                </div>
            )}
        />
    )
}

export default DatePickerControl ;
